export function SvgOverLayer({ color, id }: { color: string; id: string }) {
  return (
    <svg
      viewBox="0 0 760 1080"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-full w-full"
      id={id}
      preserveAspectRatio="xMidYMid slice"
    >
      <g clipPath="url(#clip0_50_2990)">
        <path
          d="M-58 -214H1760V1304H-58V-214Z"
          fill="#001959"
          fillOpacity="0.5"
        />
        <path
          opacity="0.5"
          d="M-58 -214H1760V1118H-58V-214Z"
          fill={`url(#paint0_linear_50_2990${id})`}
          fillOpacity="0.5"
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear_50_2990${id}`}
          x1="707"
          y1="242"
          x2="339.328"
          y2="969.394"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} stopOpacity="0" />
          <stop offset="1" stopColor={color} />
        </linearGradient>
        <clipPath id="clip0_50_2990">
          <rect width="760" height="1080" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function MarkSvg() {
  return (
    <svg
      width="761"
      height="267"
      viewBox="0 0 761 267"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute start-0 z-20 max-h-[25vh] w-max opacity-10 rtl:scale-x-[-1]"
    >
      <mask
        id="mask0_50_2996"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="-116"
        y="-271"
        width="1027"
        height="538"
      >
        <path d="M911 -271H-116V267H911V-271Z" fill="#CDCFD0" />
      </mask>
      <g mask="url(#mask0_50_2996)">
        <path
          d="M-34.2634 22.1859C-37.2955 19.3886 -39.1148 15.4038 -39.1148 11.076C-39.1148 2.7897 -32.365 -3.96597 -24.0859 -3.96597H2.75512L31.31 -24.1011H-24.1123C-43.4917 -24.1011 -59.2852 -8.32022 -59.2852 11.1024C-59.2852 19.6525 -56.2266 27.6749 -50.8743 33.9292L-34.2898 22.2123L-34.2634 22.1859Z"
          fill="#CDCFD0"
        />
        <path
          d="M63.3975 -24.1274C54.802 -24.1274 50.4779 -22.5176 43.4645 -17.5828L22.7141 -2.93673L-40.9082 41.9516C-40.6973 42.0571 -40.5127 42.1891 -40.3018 42.2946C-35.1867 44.96 -29.6234 46.2531 -24.0864 46.2531C-16.9675 46.2531 -9.87488 44.1155 -3.8106 39.814L86.9164 -24.1802H63.3975V-24.1274Z"
          fill="#CDCFD0"
        />
        <path
          d="M94.3244 25.8277C97.3565 28.625 99.1758 32.6098 99.1758 36.9376C99.1758 45.2239 92.4524 51.9795 84.1469 51.9795H57.3586L28.8301 72.0882H84.1469C103.5 72.0882 119.267 56.3338 119.267 36.9376C119.267 28.3875 116.209 20.3915 110.883 14.1372L94.3244 25.8277Z"
          fill="#CDCFD0"
        />
        <path
          d="M-6.81598 72.0618C1.75312 72.0618 11.2187 69.3964 18.2058 64.4616L37.4269 50.8711L100.944 6.06196C100.733 5.9564 100.548 5.82446 100.337 5.7189C95.2222 3.07997 89.6853 1.7605 84.1483 1.7605C77.0557 1.7605 69.9632 3.89804 63.8989 8.17311L-26.6699 72.0618H-6.81598Z"
          fill="#CDCFD0"
        />
        <path
          d="M6.62992 56.0171C-1.96555 56.0171 -6.28963 57.6269 -13.3031 62.5617L-34.0535 77.2078L-97.6758 122.096C-97.4648 122.202 -97.2803 122.334 -97.0694 122.439C-91.9543 125.104 -86.3909 126.398 -80.854 126.398C-73.735 126.398 -66.6425 124.26 -60.5782 119.959L30.1488 55.9644H6.62992V56.0171Z"
          fill="#CDCFD0"
        />
        <path
          d="M337.951 -28.2443C340.983 -25.447 342.803 -21.4623 342.803 -17.1344C342.803 -8.84813 336.079 -2.11884 327.8 -2.11884H300.986L272.457 17.9899H327.774C347.127 17.9899 362.894 2.23541 362.894 -17.1608C362.894 -25.7109 359.835 -33.7069 354.509 -39.9612L337.951 -28.2707V-28.2443Z"
          fill="#CDCFD0"
        />
        <path
          d="M236.836 18.0164C245.405 18.0164 254.871 15.351 261.858 10.4162L281.079 -3.1743L344.596 -47.9834C344.385 -48.089 344.201 -48.2209 343.99 -48.3265C338.875 -50.9654 333.338 -52.2849 327.801 -52.2849C320.708 -52.2849 313.615 -50.1474 307.551 -45.8723L216.982 18.0164H236.836Z"
          fill="#CDCFD0"
        />
        <path
          d="M152.622 48.285C149.59 45.4877 147.771 41.5029 147.771 37.1751C147.771 28.8888 154.521 22.1331 162.8 22.1331H189.641L218.222 1.99805H162.8C143.42 1.99805 127.627 17.7789 127.627 37.2015C127.627 45.7516 130.685 53.774 136.038 60.0283L152.622 48.3114V48.285Z"
          fill="#CDCFD0"
        />
        <path
          d="M250.282 1.97174C241.687 1.97174 237.363 3.58148 230.349 8.51629L209.599 23.1624L145.977 68.0507C146.187 68.1562 146.372 68.2882 146.583 68.3938C151.698 71.0591 157.261 72.3522 162.798 72.3522C169.917 72.3522 177.01 70.2146 183.074 65.9132L273.801 1.91895H250.282V1.97174Z"
          fill="#CDCFD0"
        />
        <path
          d="M281.21 51.9002C284.242 54.6975 286.062 58.6823 286.062 63.0102C286.062 71.2964 279.312 78.0257 271.033 78.0257H244.218L215.689 98.1344H271.006C290.359 98.1344 306.126 82.3799 306.126 62.9838C306.126 54.4336 303.068 46.4376 297.742 40.1833L281.184 51.8738L281.21 51.9002Z"
          fill="#CDCFD0"
        />
        <path
          d="M180.069 98.1345C188.638 98.1345 198.103 95.4692 205.091 90.5344L224.312 76.9439L287.829 32.1347C287.618 32.0292 287.433 31.8972 287.222 31.7917C282.107 29.1527 276.57 27.8333 271.033 27.8333C263.94 27.8333 256.848 29.9708 250.784 34.2459L160.215 98.1345H180.069Z"
          fill="#CDCFD0"
        />
        <path
          d="M95.8548 128.403C92.8226 125.606 91.0033 121.621 91.0033 117.293C91.0033 109.007 97.7532 102.251 106.032 102.251H132.873L161.455 82.1162H106.032C86.6529 82.1162 70.8594 97.897 70.8594 117.32C70.8594 125.87 73.9179 133.892 79.2703 140.146L95.8548 128.43V128.403Z"
          fill="#CDCFD0"
        />
        <path
          d="M193.517 82.0897C184.921 82.0897 180.597 83.6994 173.584 88.6342L152.833 103.28L89.2109 148.169C89.4219 148.274 89.6064 148.406 89.8174 148.512C94.9324 151.177 100.496 152.47 106.006 152.47C113.125 152.47 120.218 150.333 126.282 146.031L217.009 82.0369H193.49L193.517 82.0897Z"
          fill="#CDCFD0"
        />
        <path
          d="M220.33 131.781C223.362 134.578 225.182 138.563 225.182 142.891C225.182 151.177 218.458 157.906 210.179 157.906H183.364L154.836 178.015H210.153C229.506 178.015 245.273 162.261 245.273 142.864C245.273 134.314 242.214 126.318 236.888 120.064L220.33 131.754V131.781Z"
          fill="#CDCFD0"
        />
        <path
          d="M119.215 178.042C127.784 178.042 137.25 175.376 144.237 170.441L163.458 156.851L226.975 112.042C226.764 111.936 226.58 111.804 226.369 111.699C221.253 109.06 215.717 107.74 210.18 107.74C203.087 107.74 195.994 109.878 189.93 114.153L99.3613 178.042H119.215Z"
          fill="#CDCFD0"
        />
        <path
          d="M35.0013 208.31C31.9691 205.513 30.1498 201.528 30.1498 197.2C30.1498 188.914 36.8996 182.158 45.1787 182.158H72.0198L100.601 162.023H45.1787C25.7994 162.023 10.0059 177.804 10.0059 197.227C10.0059 205.777 13.0644 213.799 18.4168 220.053L35.0013 208.337V208.31Z"
          fill="#CDCFD0"
        />
        <path
          d="M132.636 161.97C124.04 161.97 119.716 163.58 112.703 168.515L91.9523 183.161L28.3301 228.049C28.541 228.155 28.7256 228.287 28.9365 228.392C34.0516 231.058 39.6149 232.351 45.1519 232.351C52.2708 232.351 59.3634 230.213 65.4277 225.912L156.155 161.917H132.636V161.97Z"
          fill="#CDCFD0"
        />
        <path
          d="M396.222 -5.97159C393.19 -8.76886 391.371 -12.7537 391.371 -17.0815C391.371 -25.3678 398.12 -32.1235 406.399 -32.1235H433.24L461.822 -52.2585H406.399C387.02 -52.2585 371.227 -36.4777 371.227 -17.0551C371.227 -8.50496 374.285 -0.482613 379.637 5.77167L396.222 -5.9452V-5.97159Z"
          fill="#CDCFD0"
        />
        <path
          d="M493.856 -52.2849C485.261 -52.2849 480.937 -50.6751 473.923 -45.7403L453.173 -31.0942L389.551 13.7941C389.762 13.8997 389.946 14.0316 390.157 14.1372C395.272 16.8025 400.836 18.0956 406.373 18.0956C413.492 18.0956 420.584 15.958 426.648 11.6566L517.375 -52.3376H493.856V-52.2849Z"
          fill="#CDCFD0"
        />
        <path
          d="M583.107 20.1275C580.075 17.3303 578.255 13.3455 578.255 9.01761C578.255 0.731346 585.005 -6.02432 593.284 -6.02432H620.125L648.706 -26.1594H593.284C573.905 -26.1594 558.111 -10.3786 558.111 9.044C558.111 17.5942 561.17 25.6165 566.522 31.8708L583.107 20.1539V20.1275Z"
          fill="#CDCFD0"
        />
        <path
          d="M680.741 -26.2123C672.146 -26.2123 667.822 -24.6026 660.808 -19.6678L640.058 -5.02169L576.436 39.8666C576.646 39.9722 576.831 40.1041 577.042 40.2097C582.157 42.875 587.72 44.1681 593.257 44.1681C600.376 44.1681 607.469 42.0305 613.533 37.7291L704.26 -26.2651H680.741V-26.2123Z"
          fill="#CDCFD0"
        />
        <path
          d="M525.68 -2.1452C528.712 0.652077 530.531 4.63687 530.531 8.96472C530.531 17.251 523.808 23.9803 515.529 23.9803H488.714L460.186 44.089H515.529C534.882 44.089 550.649 28.3345 550.649 8.93835C550.649 0.388195 547.59 -7.60778 542.264 -13.8621L525.706 -2.17157L525.68 -2.1452Z"
          fill="#CDCFD0"
        />
        <path
          d="M424.565 44.0891C433.134 44.0891 442.6 41.4238 449.587 36.489L468.808 22.8985L532.325 -21.9107C532.114 -22.0163 531.929 -22.1482 531.718 -22.2538C526.603 -24.8927 521.066 -26.2122 515.529 -26.2122C508.437 -26.2122 501.344 -24.0746 495.28 -19.7995L404.711 44.0891H424.565Z"
          fill="#CDCFD0"
        />
        <path
          d="M340.35 74.3577C337.318 71.5605 335.498 67.5757 335.498 63.2478C335.498 54.9616 342.248 48.2059 350.527 48.2059H377.368L405.923 28.0708H350.501C331.122 28.0708 315.328 43.8516 315.328 63.2742C315.328 71.8244 318.387 79.8468 323.739 86.101L340.324 74.3841L340.35 74.3577Z"
          fill="#CDCFD0"
        />
        <path
          d="M437.985 28.0442C429.39 28.0442 425.066 29.654 418.052 34.5888L397.302 49.2349L333.68 94.1232C333.891 94.2288 334.075 94.3607 334.286 94.4663C339.401 97.1316 344.965 98.4247 350.501 98.4247C357.62 98.4247 364.713 96.2871 370.777 91.9857L461.504 27.9915H437.985V28.0442Z"
          fill="#CDCFD0"
        />
        <path
          d="M468.914 77.9994C471.946 80.7966 473.766 84.7814 473.766 89.1093C473.766 97.3956 467.042 104.125 458.763 104.125H431.948L403.42 124.234H458.737C478.09 124.234 493.857 108.479 493.857 89.0829C493.857 80.5327 490.798 72.5367 485.472 66.2825L468.914 77.973V77.9994Z"
          fill="#CDCFD0"
        />
        <path
          d="M367.797 124.233C376.366 124.233 385.832 121.568 392.819 116.633L412.04 103.043L475.557 58.2336C475.346 58.1281 475.162 57.9961 474.951 57.8905C469.836 55.2516 464.299 53.9321 458.762 53.9321C451.669 53.9321 444.576 56.0697 438.512 60.3447L347.943 124.233H367.797Z"
          fill="#CDCFD0"
        />
        <path
          d="M283.584 154.502C280.552 151.705 278.733 147.72 278.733 143.392C278.733 135.106 285.483 128.35 293.762 128.35H320.603L349.158 108.215H293.735C274.356 108.215 258.562 123.996 258.562 143.418C258.562 151.969 261.621 159.991 266.973 166.245L283.558 154.528L283.584 154.502Z"
          fill="#CDCFD0"
        />
        <path
          d="M381.218 108.189C372.622 108.189 368.298 109.799 361.285 114.733L340.534 129.379L276.912 174.268C277.123 174.373 277.308 174.505 277.519 174.611C282.634 177.276 288.197 178.569 293.734 178.569C300.853 178.569 307.945 176.432 314.01 172.13L404.737 108.136H381.218V108.189Z"
          fill="#CDCFD0"
        />
        <path
          d="M408.061 166.404C411.093 169.201 412.912 173.186 412.912 177.514C412.912 185.8 406.189 192.529 397.91 192.529H371.095L342.566 212.638H397.883C417.236 212.638 433.003 196.883 433.003 177.487C433.003 168.937 429.945 160.941 424.619 154.687L408.061 166.377V166.404Z"
          fill="#CDCFD0"
        />
        <path
          d="M306.944 212.638C315.513 212.638 324.952 209.973 331.966 205.038L351.187 191.447L414.703 146.638C414.493 146.533 414.308 146.401 414.097 146.295C408.982 143.656 403.445 142.337 397.908 142.337C390.815 142.337 383.723 144.474 377.659 148.749L287.09 212.638H306.944Z"
          fill="#CDCFD0"
        />
        <path
          d="M222.73 242.907C219.698 240.109 217.878 236.125 217.878 231.797C217.878 223.51 224.628 216.755 232.907 216.755H259.748L288.33 196.62H232.907C213.528 196.62 197.734 212.4 197.734 231.823C197.734 240.373 200.793 248.396 206.145 254.65L222.73 242.933V242.907Z"
          fill="#CDCFD0"
        />
        <path
          d="M320.364 196.593C311.769 196.593 307.445 198.203 300.431 203.138L279.681 217.784L216.059 262.672C216.27 262.778 216.454 262.91 216.665 263.015C221.78 265.681 227.343 266.974 232.854 266.974C239.973 266.974 247.066 264.836 253.13 260.535L343.857 196.541H320.338L320.364 196.593Z"
          fill="#CDCFD0"
        />
        <path
          d="M712.567 23.9276C715.599 26.7249 717.418 30.7096 717.418 35.0375C717.418 43.3238 710.668 50.0531 702.389 50.0531H675.601L647.072 70.1617H702.389C721.742 70.1617 737.509 54.4073 737.509 35.0111C737.509 26.4609 734.451 18.465 729.125 12.2107L712.567 23.9012V23.9276Z"
          fill="#CDCFD0"
        />
        <path
          d="M611.452 70.188C620.021 70.188 629.486 67.5227 636.473 62.5879L655.695 48.9973L719.211 4.18818C719 4.08262 718.816 3.95068 718.605 3.84512C713.49 1.20619 707.953 -0.113281 702.416 -0.113281C695.323 -0.113281 688.231 2.02426 682.166 6.29934L591.598 70.188H611.452Z"
          fill="#CDCFD0"
        />
        <path
          d="M527.236 100.457C524.204 97.6593 522.384 93.6746 522.384 89.3467C522.384 81.0604 529.134 74.3048 537.413 74.3048H564.254L592.835 54.1697H537.413C518.034 54.1697 502.24 69.9505 502.24 89.3731C502.24 97.9232 505.299 105.946 510.651 112.2L527.236 100.483V100.457Z"
          fill="#CDCFD0"
        />
        <path
          d="M624.872 54.117C616.277 54.117 611.953 55.7267 604.939 60.6616L584.189 75.3076L520.566 120.196C520.777 120.302 520.962 120.433 521.173 120.539C526.288 123.204 531.851 124.497 537.388 124.497C544.507 124.497 551.6 122.36 557.664 118.058L648.391 54.0642H624.872V54.117Z"
          fill="#CDCFD0"
        />
        <path
          d="M655.799 104.072C658.831 106.869 660.65 110.854 660.65 115.182C660.65 123.468 653.927 130.198 645.648 130.198H618.833L590.305 150.306H645.621C664.974 150.306 680.742 134.552 680.742 115.156C680.742 106.605 677.683 98.6095 672.357 92.3552L655.799 104.046V104.072Z"
          fill="#CDCFD0"
        />
        <path
          d="M554.684 150.306C563.253 150.306 572.719 147.641 579.706 142.706L598.927 129.115L662.444 84.3064C662.233 84.2008 662.048 84.0688 661.837 83.9633C656.722 81.3244 651.185 80.0049 645.648 80.0049C638.556 80.0049 631.463 82.1424 625.399 86.4175L534.83 150.306H554.684Z"
          fill="#CDCFD0"
        />
        <path
          d="M470.47 180.575C467.438 177.778 465.619 173.793 465.619 169.465C465.619 161.179 472.368 154.423 480.647 154.423H507.489L536.07 134.288H480.647C461.268 134.288 445.475 150.069 445.475 169.491C445.475 178.041 448.533 186.064 453.886 192.318L470.47 180.601V180.575Z"
          fill="#CDCFD0"
        />
        <path
          d="M568.105 134.262C559.509 134.262 555.185 135.871 548.172 140.806L527.421 155.452L463.799 200.34C464.01 200.446 464.194 200.578 464.405 200.684C469.52 203.349 475.084 204.642 480.621 204.642C487.74 204.642 494.832 202.504 500.896 198.203L591.623 134.209H568.105V134.262Z"
          fill="#CDCFD0"
        />
      </g>
    </svg>
  );
}
